import React from "react";
import { IconButton, Tooltip, useTheme } from "@mui/material";

export default function CustomHeaderButton({
    active,
    onClick,
    icon,
    tooltip = "Filter by Category",
    sx
}) {
    const theme = useTheme();

    return (
        <Tooltip title={tooltip} arrow>
            <IconButton
                onClick={onClick}
                sx={{
                    borderRadius: 2.5,
                    backgroundColor: active
                        ? theme.palette.action.selected
                        : theme.palette.background.paper,
                    color: active
                        ? theme.palette.primary.main
                        : theme.palette.text.secondary,
                    border: `1px solid ${theme.palette.divider}`,
                    boxShadow: active
                        ? theme.palette.mode === "light"
                            ? "0 2px 8px 0 rgba(2,89,165,0.08)"
                            : "0 2px 8px 0 rgba(0,188,212,0.10)"
                        : undefined,
                    "&:hover": {
                        backgroundColor: theme.palette.action.hover,
                    },
                    m: 0.5,
                    transition: "box-shadow 0.17s, background 0.18s, color 0.12s",
                    ...sx,
                }}
            >
                {icon}
            </IconButton>
        </Tooltip>
    );
}